import React from "react";
import { Link } from "react-router-dom";
import HeadMeta from "@/components/sections/HeadMeta";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import Subvencio from "@/components/sections/Subvencio";
import { usePageInitialization } from "@/hooks/usePageInitialization";

const AvisoLegalPage = () => {
  usePageInitialization("Aviso legal - Elemental Value", { handleSplash: false, initSwiper: false });
  
  return (
    <>
      <HeadMeta
        title="Aviso legal | Elemental Value"
        description="Información legal de EV23 FINANCE, S.L. (Elemental Value): datos identificativos, propiedad intelectual, exclusión de responsabilidad y legislación aplicable."
        canonicalPath="/aviso-legal"
      />
      <Header />
      <main className="legal-page">
        <div className="legal-content">
          <h1>Aviso legal</h1>
          
          <section>
            <h2>1. Datos Identificativos</h2>
            <p>
              En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa que el titular de este sitio web es:
            </p>
            <ul>
              <li><strong>Denominación social:</strong> EV23 FINANCE, S.L.</li>
              <li><strong>NIF:</strong> B26586594</li>
              <li><strong>Domicilio social:</strong> Calle Diputació, número 238, planta 5ª, puerta 1ª, C.P. 08007 - Barcelona</li>
              <li><strong>Email de contacto:</strong> info@elementalvalue.co</li>
            </ul>
          </section>

          <section>
            <h2>2. Objeto y Ámbito de Aplicación</h2>
            <p>
              El presente aviso legal regula el uso del sitio web que EV23 FINANCE, S.L. (en adelante, "Elemental Value") pone a disposición de los usuarios de Internet. La utilización del sitio web atribuye la condición de usuario e implica la aceptación plena de todas las condiciones incluidas en este Aviso legal, así como en la <Link to="/politica-privacidad">Política de privacidad</Link> y la <Link to="/politica-cookies">Política de cookies</Link>.
            </p>
          </section>

          <section>
            <h2>3. Propiedad Intelectual e Industrial</h2>
            <p>
              Todos los contenidos del sitio web, incluyendo textos, fotografías, gráficos, imágenes, iconos, tecnología, software, así como su diseño gráfico y códigos fuente, constituyen una obra cuya propiedad pertenece a Elemental Value, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación sobre los mismos más allá de lo estrictamente necesario para el correcto uso de la web.
            </p>
            <p>
              Las marcas, nombres comerciales o signos distintivos son titularidad de Elemental Value o de terceros, sin que pueda entenderse que el acceso al sitio web atribuya ningún derecho sobre los mismos.
            </p>
          </section>

          <section>
            <h2>4. Exclusión de Garantías y Responsabilidad</h2>
            <p>
              Elemental Value no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
            </p>
          </section>

          <section>
            <h2>5. Modificaciones</h2>
            <p>
              Elemental Value se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados en su portal.
            </p>
          </section>

          <section>
            <h2>6. Enlaces</h2>
            <p>
              En el caso de que en el sitio web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, Elemental Value no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.
            </p>
          </section>

          <section>
            <h2>7. Legislación Aplicable y Jurisdicción</h2>
            <p>
              La relación entre Elemental Value y el usuario se regirá por la normativa española vigente, siendo de aplicación la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), el Reglamento (UE) 2016/679 General de Protección de Datos (RGPD), la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), y demás normativa aplicable.
            </p>
            <p>
              Para la resolución de cualquier controversia que pudiera surgir, las partes se someten a los Juzgados y Tribunales de la ciudad de Barcelona, salvo que la Ley aplicable disponga otra cosa.
            </p>
          </section>
        </div>
      </main>
      <Footer />
      <Subvencio />
    </>
  );
};

export default AvisoLegalPage;
